import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

import PageLayout from "../_layout/PageLayout";
import { MyAccountMenuItemsModel } from "./MyAccountMenuItems";
import { currentUserService } from "../../services/user/CurrentUserStorage";
import { api } from "../../services/api/ApiService";
import { MyOrganizationInvitationsStorageModel } from "../../services/organization/MyOrganizationInvitationsStorage";
import {
  ActionsSection,
  ButtonsSection,
} from "../../components/data-components/sections/DataSections";
import { AcceptInvitationRequestButton } from "./components/buttons/AcceptInvitationRequestButton";
import { RejectInvitationRequestButton } from "./components/buttons/RejectInvitationRequestButton";
import DataGrid from "../../components/datatable/DataGrid";
import { EmploymentStatusesStorageModel } from "../../services/user/EmploymentStatusesStorage";
import { UserRolesStorageModel } from "../../services/user/UserRolesStorage";

export default observer(() => {
  const [userRolesStorage] = useState(() => UserRolesStorageModel.create({}, { api }));

  const [employmentStatusesStorage] = useState(() =>
    EmploymentStatusesStorageModel.create({}, { api })
  );
  const [myOrganizationInvitationsStorage] = useState(() =>
    MyOrganizationInvitationsStorageModel.create(
      { useGridFiltering: true, autoLoad: false },
      { api }
    )
  );

  const [myAccountMenuItems] = useState(() => MyAccountMenuItemsModel.create({}));

  useEffect(() => {
    if (userRolesStorage.isLoading || employmentStatusesStorage.isLoading) {
      return;
    }

    myOrganizationInvitationsStorage.setUserRoleOptions(toJS(userRolesStorage.userRoles));
    myOrganizationInvitationsStorage.setEmploymentStatusOptions(
      toJS(employmentStatusesStorage.employmentStatuses)
    );

    async function load() {
      await myOrganizationInvitationsStorage.load();
    }

    load();
  }, [
    employmentStatusesStorage.employmentStatuses,
    employmentStatusesStorage.isLoading,
    myOrganizationInvitationsStorage,
    userRolesStorage.isLoading,
    userRolesStorage.userRoles,
  ]);

  const menuItems = {
    staticItems: myAccountMenuItems.getStaticItems(),
  };

  return (
    <PageLayout
      titleKey="MyAccount.collaboration-requests"
      id="view-collaboration-requests"
      menuItems={menuItems}
      isLoading={currentUserService.isLoading}
    >
      <ActionsSection>
        <ButtonsSection>
          <AcceptInvitationRequestButton
            invitationRequestsStorage={myOrganizationInvitationsStorage}
          />
          <RejectInvitationRequestButton
            invitationRequestsStorage={myOrganizationInvitationsStorage}
          />
        </ButtonsSection>
      </ActionsSection>
      <DataGrid
        itemTypeKey="general.collaboration-requests"
        dataGridStorage={myOrganizationInvitationsStorage}
        singleSelection
        noResultsMessageKey="MyAccount.collaboration-requests.no-results"
      />
    </PageLayout>
  );
});
